<template>
    <div class="sidebar-outline" :class="{closed: isClose, top: isTop}">
        <button type="button"
            id="btn-toggle"
            class="btn btn-outline-secondary btn-lg"
            :style="buttonStyle"
            :class="{closed: isClose, cloudy: isWriting}"
            @click="toggle()">
            <i class="fas fa-list" v-if="isClose || (!isClose && !isTop)"></i>
            <i class="fas fa-times" v-else></i>
        </button>
        <div class="sidebar" id="content-sidebar" :class="{closed: isClose}">
            <div class="sidebar-body">
                <div class="sidebar-wrapper">
                    <div class="sticky" style="top:0">
                        <button type="button" class="btn btn-light btn-block btn-square" @click="toggle()">
                            閉じる
                            <i class="fas fa-chevron-right"></i>
                        </button>
                    </div>
                    <div class="list-group list-group-flush" id="list-group-content">
                        <template
                            v-for="s in sections"
                            :key="s.id">
                            <router-link :to="`/mypage/book/${book_id}/section/edit/${s.id}`"
                                class="list-group-item list-group-item-action"
                                :class="{
                                    active: $route.params.id == s.id,
                                    disabled: disabled || s.is_chapter,
                                    chapter: s.is_chapter,
                                }">
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex justify-content-start">
                                        <div class="list-content clickable" @click.prevent="toggleSub(s)">
                                            <i v-if="$route.params.id == s.id" class="fas fa-pencil-alt"></i>
                                            <i v-else-if="!s.is_chapter && !s.is_opened" class="fas fa-chevron-down"></i>
                                            <i v-else-if="!s.is_chapter" class="fas fa-chevron-up"></i>
                                        </div>
                                        <div class="list-content">
                                            <span v-html="$filters.ruby(s.section_name || '（無題）')"></span>
                                        </div>
                                    </div>
                                    <div v-if="!s.is_chapter" class="list-content">
                                        <span class="badge badge-success badge-pill" v-if="isPublished(s)">公開済み</span>
                                        <span class="badge badge-secondary badge-pill" v-else>下書き</span>
                                    </div>
                                </div>
                            </router-link>
                            <div class="sub-window" v-if="s.is_opened">
                                <div class="triangle"></div>
                                <div class="sub-content">
                                    <div v-html="$filters.ruby(s.body || '')" class="mb-3"></div>
                                    <div class="d-flex justify-content-center">
                                        <button class="btn btn-light btn-sm" @click.prevent="toggleSub(s)">
                                            <i class="fas fa-times"></i>
                                            閉じる
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <router-link :to="`/mypage/book/${book_id}/section/edit/new`"
                            class="list-group-item list-group-item-action"
                            :class="{active: $route.params.id == 'new'}">
                            <div class="list-content">
                                <i class="fas fa-plus"></i>
                                新規本文追加
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="./sidebar.scss" scoped lang="scss"></style>
<style scoped lang="scss">
.list-group-item {
    padding: 0;
    &.chapter {
        font-weight: bold;
        font-size: 1rem;
    }
}
.list-content {
    padding: 0.75rem 1.25rem;
}
.clickable {
    &:hover {
        opacity: .6;
        background-color: #99999922;
    }
}
.sub-window {
    padding: 1.5rem 1.25rem;
    position: relative;
    .triangle {
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -15px;
        margin-top: 4px;
        height: 20px;
        width: 30px;
        clip-path: polygon(50% 0, 100% 100%, 0 100%);
        background-color: #99999922;
    }
    .sub-content {
        padding: 1rem;
        font-size: 0.8rem;
        border-radius: .75rem;
        background-color: #99999922;
    }
}
</style>

<script>
export default {
    props: {
        book_id: {
            required: true,
        },
        disabled: {
            default: false,
        },
        order: {
            default: 2
        },
        isWriting: {
            default: false,
        },
    },
    data() {
        return {
            sections: [],
            isClose: true,
            isTop: false,
        }
    },
    methods: {
        load() {
            axios.get("/mypage/book/sections/get", {params: {id: this.book_id}}).then(res => {
                const cached = _.filter(this.contents, 'body');
                for (const c of cached) {
                    const data = _.find(res.data, {id: c.id})
                    data.body = c.body;
                }
                this.sections = res.data;
            }).catch(err => {
                alert.err(err.response);
            });
        },
        toggleSub(s) {
            if (s.id == this.$route.params.id) {
                return;
            }
            if (s.is_opened) {
                s.is_opened = false;
            } else {
                if (s.body) {
                    s.is_opened = true;
                } else {
                    this._loadBody(s);
                }
            }
        },
        _loadBody(s) {
            axios.get(`/mypage/book/section/body`, { params: {
                'id': s.id,
                'book_id': s.book_id,
            }}).then(res => {
                s.body = res.data.body;
                s.is_opened = true;
            }).catch(err => { alert.err(err) });
        },
        toggle(isClose = null) {
            if (isClose !== null) {
                this.isClose = isClose;
                this.isTop = false;
            } else {
                if (!this.isClose && !this.isTop) {
                    this.isTop = true;
                } else {
                    this.isClose = !this.isClose;
                    this.isTop = !this.isClose;
                }
                this.$emit("toggle", this.isClose);
            }
            if (!this.isClose && this.isTop) {
                const top = $("#list-group-content .active")[0].offsetTop - 43;
                $("#content-sidebar").animate({scrollTop: top}, 300);
            }
        },
        isPublished(s) {
            if (moment(s.publish_at).isSameOrBefore(moment())) {
                return true;
            }
            return false;
        }
    },
    watch: {
        book_id(n, o) {
            this.load();
        },
        '$route.params.id'(n, o) {
            if (n) {
                const s = _.find(this.sections, {id: parseInt(n)});
                if (s) {
                    s.body = null;
                    s.is_opened = false;
                }
            }
        }
    },
    computed: {
        buttonStyle() { return { "top": (this.order * 46 + 50) + "px" }; },
    },
    mounted() {
        this.load();
    }
}
</script>